/**
 * @author jzhu 2020-01-17
 * 人员管理范围
 */
import React from 'react'
import { connect } from 'dva'
import { modelUtils } from '../../../../utils'
import '@/styles/containers/personManage/administrationScope/index.less'
import { component_tool, framework_tool, utils_tool } from '../../../../tool'
let {
    WizSpin,
    WizCard,
    WizRow,
    WizCol,
    WizTabs,
    WizCollapse,
    WizButton,
    WizSearchBar,
    WizDataTable,
    WizModalForm,
    WizModal,
    WizAlert
} = component_tool
let { WizContainer } = framework_tool
let { Session, getPageData } = utils_tool

import createColumns from './columns'

const getParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/org/person/administrationScope') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('administrationScope', record)
        } else {
            record = Session.get('administrationScope') || {}
        }
    }
    return record
}

class AdministrationScope extends WizContainer {
    componentName = 'AdministrationScope'

    constructor(props) {
        super(props)
        let { history } = props
        this._person = getParamRecord(history)
        let defaultStatus = {
            record: null,
            visible: false,
            selectedRows: 0,
            keys: [],
            rows: []
        }
        this.state = {
            modalKey: '',
            7: { ...defaultStatus },
            6: { ...defaultStatus }
        }
    }

    propsAndStateOnChange = {
        createOrgAuthority: this._createOrgAuthorityOnChange.bind(this),
        deleteOrgAuthority: this._deleteOrgAuthorityOnChange.bind(this),
        enable: this._enableOnChange.bind(this),
    }

    _createOrgAuthorityOnChange(nextProps, nextState) {
        if (nextProps.createOrgAuthority.actionCompleteTime !== this.props.createOrgAuthority.actionCompleteTime) {
            if (nextProps.createOrgAuthority.code === 1) {
                this._getOrgAuthorityInfo(nextProps.createOrgAuthority.data.managerType)
            } else {
                wizNotice.error(nextProps.createOrgAuthority.msg)
            }
        }
        return true
    }

    _deleteOrgAuthorityOnChange(nextProps, nextState) {
        if (nextProps.deleteOrgAuthority.actionCompleteTime !== this.props.deleteOrgAuthority.actionCompleteTime) {
            if (nextProps.deleteOrgAuthority.code === 1) {
                this._getOrgAuthorityInfo(nextProps.deleteOrgAuthority.data.managerType)
            } else {
                wizNotice.error(nextProps.deleteOrgAuthority.msg)
            }
        }
        return true
    }

    _enableOnChange(nextProps, nextState) {
        if (nextProps.enable.actionCompleteTime !== this.props.enable.actionCompleteTime) {
            if (nextProps.enable.code === 1) {
                this._getOrgAuthorityInfo(nextProps.enable.data.managerType)
            } else {
                wizNotice.error(nextProps.enable.msg)
            }
        }
        return true
    }

    _componentDidMount = () => {
        let keys = [
            7,
            6
        ]
        keys.forEach(key => this._getOrgAuthorityInfo(key))
    }

    _getOrgAuthorityInfo(managerType, apiParams = {}) {
        if (this.state[managerType] && this.state[managerType].selectedRows > 0) {
            this._onSelect([], [], managerType)
        }
        this.doAction({
            path: 'orgAuthority/getOrgAuthorityInfo',
            payload: {
                key: managerType + '@' + this._person.personId,
                apiParams: { managerType, current: 1, size: 10, personId: this._person.personId, ...apiParams }
            }
        })
    }

    _createOrgAuthority(managerType, values = {}) {
        this.doAction({
            path: 'orgAuthority/createOrgAuthority',
            payload: {
                key: 'orgAuthority@createOrgAuthority',
                apiParams: { managerType, personId: this._person.personId, ...values }
            }
        })
    }

    _deleteOrgAuthority(managerType) {
        WizModal.confirm({
            title: '注意',
            content: '删除后数据不可恢复，您确定要删除选中的数据吗？',
            onOk: () => {
                this.doAction({
                    path: 'orgAuthority/deleteOrgAuthority',
                    payload: {
                        key: 'orgAuthority@deleteOrgAuthority',
                        apiParams: { managerType, ids: this.state[managerType].keys }
                    }
                })
            },
            onCancel() {
            }
        });
    }

    _enableOrgAuthority(managerType, state) {
        // 您确定修改【xx】状态为禁用吗？
        const content = `您确定修改选中的数据状态为${state === 0 ? '禁用' : '启用'}吗`

        WizModal.confirm({
            title: '注意',
            content,
            onOk: () => {
                this.doAction({
                    path: 'orgAuthority/enableOrgAuthority',
                    payload: {
                        key: 'orgAuthority@enable',
                        apiParams: { managerType, state, ids: this.state[managerType].keys }
                    }
                })
            },
            onCancel() {
            }
        });
    }

    _renderContentRow(ln, lv = '', rn, rv = '') {
        return (
            <WizRow className='administrationScope-row-item'>
                <WizCol className='col-item' span={3} offset={1}>{ln + '：'}</WizCol>
                <WizCol span={6}>{lv}</WizCol>
                <WizCol className='col-item' span={3} offset={2}>{rn + '：'}</WizCol>
                <WizCol span={9}>{rv}</WizCol>
            </WizRow>
        )
    }

    _setModalStatus(key, record, visible) {
        this.setState({
            modalKey: key,
            [key]: {
                ...this.state[key],
                record,
                visible
            }
        })
    }

    _removeSelectedRows(key) {
        this.setState({
            [key]: {
                ...this.state[key],
                selectedRows: 0,
                keys: [],
                rows: [],
            }
        })
    }

    _onSelect(keys, rows, key) {
        this.setState({
            [key]: {
                ...this.state[key],
                keys,
                rows,
                selectedRows: keys.length
            }
        })
    }

    _getType (key) {
        let types = {
            6: 'AdministrationSubjectToOrgPositionCategory',
            7: 'AdministrationSubjectToOrgPosition'
        }
        return types[key]
    }

  /**
   * 渲染操作按钮 且 进行权限检查
   */
  _renderBtn = (selectedRows, key) => {
    let r = []
    let btns = new Map();
    btns.set('add', <WizButton title='新增' type='primary' onClick={e => this._setModalStatus(key, null, true)} icon='plus'>新增</WizButton>);
    btns.set('delete', <WizButton title='删除' type='danger' onClick={e => this._deleteOrgAuthority(key)} icon='delete' disabled={selectedRows < 1}>删除</WizButton>);
    btns.set('disable', <WizButton title='禁用' onClick={e => this._enableOrgAuthority(key, 0)} disabled={selectedRows < 1}>禁用</WizButton>);
    btns.set('enable', <WizButton title='启用' onClick={e => this._enableOrgAuthority(key, 1)} disabled={selectedRows < 1}>启用</WizButton>);
    let btnCode = this.getMenuBtn() || [];
    btnCode.map(({ code }) => {
      if (btns.has(code)) {
        r.push(btns.get(code))
      }
    })
    return r
  }

    _renderSearchTable(key, title) {
        let type = this._getType(key)
        let { record, visible, selectedRows, rows } = this.state[key]
        let other = {
            type
        }
        let columns = createColumns(this, other)
        let searchBarProps = {
            columns,
            onSearch: values => this._getOrgAuthorityInfo(key, values)
        }
        let dataTableProps = {
            columns,
            rowKey: 'id',
            dataItems: getPageData(this.props[type] && this.props[type].data),
            selectType: 'checkbox',
            showNum: false,
            isScroll: true,
            onChange: ({ pageNum, pageSize }) => {
                this._getOrgAuthorityInfo(key, { current: pageNum, size: pageSize })
            },
            selectedRowKeys: rows.map(item => item.rowKey),
            onSelect: (keys, rows) => this._onSelect(keys, rows, key)
        }
        let modalFormProps = {
            record,
            visible,
            columns,
            modalOpts: {
                width: 700
            },
            onCancel: () => this._setModalStatus(key, null, false),
            onSubmit: values => {
                this._setModalStatus(key, null, false)
                this._createOrgAuthority(key, values)
            }
        }
        return (
            <WizCollapse.Panel key={key} header={title} className='panel-item'>
                <WizCard>
                    <WizSearchBar key={key + '_searchBar'} type='grid' {...searchBarProps} />
                </WizCard>
                <WizCard>
                  <WizButton.WizGroup>
                    {this._renderBtn(selectedRows, key)}
                  </WizButton.WizGroup>
                    <WizAlert
                        className='alert'
                        type='info'
                        message={<Message selectedRows={selectedRows} removeSelectedRows={() => this._removeSelectedRows(key)} />}
                        showIcon={true}
                    />
                    <WizDataTable key={key + '_dataTable'} {...dataTableProps} />
                    <div className='pagination'>
                        <WizDataTable.Pagination key={key + '_pagination'} {...dataTableProps} />
                    </div>
                </WizCard>
                <WizModalForm key={key + '_modalForm'} {...modalFormProps} />
            </WizCollapse.Panel>
        )
    }

    _getValue(type, key) {
        const values = {
            gender: {
                0: '男',
                1: '女',
                2: '未知',
            },
            userType: {
              0: '培训平台用户',
              3: 'OEM部门用户',
              4: '经销商用户',
              5: '服务商用户'
            },
            state: {
                1: '激活',
                0: '禁用'
            }
        }
        return values[type][key]
    }

    _render() {
        let londing = this.props.orgAuthorityLoading
        return (
            <>
                <WizSpin tip={'加载中'} spinning={londing}>
                    <WizCard title={'人员基本信息'} >
                        {this._renderContentRow('账号', this._person.userName, '姓名', this._person.fullName)}
                        {this._renderContentRow('昵称', this._person.nickName, '用户属性', this._getValue('userType', this._person.userType))}
                        {this._renderContentRow('性别', this._getValue('gender', this._person.gender) , '手机号', this._person.mobile)}
                        {this._renderContentRow('邮箱', this._person.email, '状态', this._getValue('state', this._person.state))}
                    </WizCard>
                    <WizCard>
                        <WizCollapse className='administrationScope-collapse'
                            expandIconPosition='right'
                            defaultActiveKey={[
                                7,
                                6
                            ]}
                        >
                            {this._renderSearchTable(7, '管理组织岗位')}
                            {this._renderSearchTable(6, '管理组织岗位分类')}
                        </WizCollapse>
                    </WizCard>
                </WizSpin>
            </>
        )
    }
}

const Message = ({ selectedRows, removeSelectedRows }) => (
    <>
        已选择 {selectedRows} 项
        <WizButton
            style={{ height: 20 }}
            type='link'
            tooltip='清空'
            onClick={() => removeSelectedRows()}
        >
            {' 清空'}
        </WizButton>
    </>
)

const mapStateToProps = (state, ownProps) => {
    const { orgAuthority } = state
    const createOrgAuthority = modelUtils.getModelEntity(orgAuthority, 'orgAuthority@createOrgAuthority')
    const deleteOrgAuthority = modelUtils.getModelEntity(orgAuthority, 'orgAuthority@deleteOrgAuthority')
    const enable = modelUtils.getModelEntity(orgAuthority, 'orgAuthority@enable')

    const { history } = ownProps
    let record = getParamRecord(history)
    const AdministrationSubjectToOrgPosition = modelUtils.getModelEntity(orgAuthority, '7@' + record.personId)
    const AdministrationSubjectToOrgPositionCategory = modelUtils.getModelEntity(orgAuthority, '6@' + record.personId)

    const load = modelUtils.getLoadingState(state, 'orgAuthority')
    return {
        createOrgAuthority,
        deleteOrgAuthority,
        enable,
        AdministrationSubjectToOrgPosition,
        AdministrationSubjectToOrgPositionCategory,
        ...load
    }
}

export default connect(mapStateToProps)(AdministrationScope)
